var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Child 2")]),_vm._v(" "+_vm._s(_vm.localValue)+" "),_c('button',{on:{"click":function($event){++_vm.localValue}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }